import React, { Component } from 'react';

class Register extends Component {
  render() {
    return (
      <div>
       <p>hello</p>
      </div>
    );
  }
}

export default Register
